import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Event, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Application } from '@enums/application.enums';
import { CommonService } from '@shared/services/common.service';
import { AuthService } from '@core/auth.service';
import { appRoutingUrl } from '@enums/comman.enums';
import { HeaderFooterStateService } from '@modules/shared/services/header-footer-state.service';
import { ROUTE_PATHS } from '@constants/routes';
import { DOWNLOAD_LINKS } from '@modules/shared/components/footer/footer.constants';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  hideFooterMenu = false;
  copyRightYear;
  isLogedIn;
  whitelabelUserData;
  whiteLabelConfig;
  scrSize = 0;
  appRoutingUrl = appRoutingUrl;
  backgroundColor: string | null = null;
  themeColor: string | null = null;
  isFooterVisible = false;
  ROUTE_PATHS = ROUTE_PATHS;
  DOWNLOAD_LINKS = DOWNLOAD_LINKS;
  constructor(
    private readonly router: Router,
    public readonly cs: CommonService,
    private readonly authService: AuthService,
    private readonly headerFooterStateService: HeaderFooterStateService
  ) {
    if (this.cs.isBrowser) {
      this.scrSize = window.innerWidth;
    }
    this.getYear();
  }

  ngOnInit(): void {
    if (this.cs.isBrowser){
      this.isLogedIn = this.authService.isAuthenticated();
      const config = this.cs.getWhiteLabelConfiguration();
      if (config) {
        this.whitelabelUserData = config.user;
        this.whiteLabelConfig = config.data.whiteLabel;
      }
    }

    this.headerFooterStateService.footerStateSubject.subscribe(state => {    
      this.backgroundColor = state.footerBackgroundColor;
      this.themeColor = state.footerThemeColor;
      this.isFooterVisible = state.isFooterVisible && !this.authService.isWhiteLabelWebsite();
      if(this.isFooterVisible && this.cs.isBrowser) {
        this.isLogedIn = this.authService.isAuthenticated();
      }
    });
  }

  getYear() {
    this.copyRightYear = `${new Date().getFullYear()}`;
  }

  hideFooter() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects === '/') {
          this.hideFooterMenu = false;
        } else if (event.urlAfterRedirects.includes(Application.userProfile)) {
          this.hideFooterMenu = false;
        } else if (event.urlAfterRedirects.includes(Application.dashboard)) {
          this.hideFooterMenu = true;
        } else if (event.urlAfterRedirects.includes('home')) {
          this.hideFooterMenu = false;
        } else if (event.urlAfterRedirects.includes('/edit-preference')) {
          this.hideFooterMenu = false;
        } else {
          this.hideFooterMenu = true;
        }
      }
    });
  }

  SocualMedialLinks = [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/topfan/',
      icon: 'icon-litefacebook-logo'
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/topfan/',
      icon: 'icon-liteinstagram-logo'
    },
    {
      name: 'Google+',
      href: 'https://accounts.google.com/signin/v2/identifier?hl=en-GB&continue=https%3A%2F%2Fwww.google.com%3Fhl%3Den-GB&ec=GAlA8wE&flowName=GlifWebSignIn&flowEntry=AddSession',
      icon: 'icon-google'
    },
    { name: 'X', href: 'https://twitter.com/topfans', icon: 'icon-litetwitter-logo' },
    {
      name: 'TikTok',
      href: 'https://www.tiktok.com/@topfan',
      icon: 'icon-litetiktok-logo'
    }
  ];
}
